import {
  CButton,
  CForm,
  CLoadingButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import PlayerService from 'src/service/PlayerService'
import ToastComponent from 'src/components/common/TaostComponent'

const SetCategoryModal = ({ visible, onClose, playerIds, pcrTerm, onSuccess }) => {
  const [loadingType, setLoadingType] = useState(null)

  const handleClose = () => {
    setLoadingType(null)
    onClose()
  }

  const handleSubmit = (type) => {
    setLoadingType(type)
    PlayerService.updateExternalPlayers({ player_ids: playerIds, type: Number(type) })
      .then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          onSuccess()
          handleClose()
        } else {
          ToastComponent(res.message, 'error')
        }
        setLoadingType(null)
      })
      .catch(() => {
        ToastComponent('Something went wrong', 'error')
        setLoadingType(null)
      })
  }

  const categoryName = pcrTerm?.name || 'category'

  return (
    <CModal visible={visible} onClose={handleClose}>
      <CForm>
        <CModalHeader>
          <CModalTitle>Set Position Category Restriction</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="text-medium-emphasis">
            Update {categoryName} for {playerIds.length} selected player
            {playerIds.length !== 1 ? 's' : ''}.
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="outline" onClick={handleClose}>
            Cancel
          </CButton>
          <CLoadingButton
            color="danger"
            variant="outline"
            loading={loadingType === '0'}
            disabled={loadingType !== null && loadingType !== '0'}
            onClick={() => handleSubmit('0')}
          >
            Remove
          </CLoadingButton>
          <CLoadingButton
            color="primary"
            loading={loadingType === String(pcrTerm?.id)}
            disabled={loadingType !== null && loadingType !== String(pcrTerm?.id)}
            onClick={() => handleSubmit(pcrTerm?.id)}
          >
            Assign
          </CLoadingButton>
        </CModalFooter>
      </CForm>
    </CModal>
  )
}

export default SetCategoryModal
